import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './symbolInfoPreview.png';

export const symbolInfoDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Symbol info provides basic information such as exchange, lot
                size, quote size, and sector.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'symbol-info-preview' }],
};
